/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import Map from "../../../components/Map";
import Card from "@mui/material/Card";
import {TextField} from "@mui/material";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

function Address({ event }) {
  const { name, address: addressV, city: cityV, state: stateV, lat: latV, lon: lonV } = event;

  const center = {
    lat: latV,
    lng: lonV
  };
  const backgroundColor = {
    style: {backgroundColor: 'rgb(255, 255, 255)'}
  }
  return (
    <Card>
      <MDBox p={3}>
        <MDTypography variant="h5" fontWeight="bold">
          Address
        </MDTypography>
        <MDBox mt={1.625}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <MDTypography variant="body2" >
                {addressV}
              </MDTypography>
              <MDTypography variant="body2" >
                {cityV}, {stateV}
              </MDTypography>
            </Grid>
          </Grid>
          <Grid container mt={0.5} spacing={3}>
            <Grid item xs={12} alignContent="center">
              <MDTypography variant="h5" fontWeight="bold">
                Event Location
              </MDTypography>
            </Grid>
            <Grid item xs={12} alignContent="center">
              <Map center={center} eventName={name}
                   style={{ height: "60vh", width: "90vh" }} isStartAtPoint={true}/>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </Card>
  );
}



export default Address;
